
const sentencesConfig = {
    id: 'sentences',
    title: 'Sentences Exercise',
    backgroundColor: '#12101e',
    headerColor: '#883C96',
    planetImage: '/assets/images/general/pianeta_blu.png',
    planetBackground: '/assets/images/hiding/planet-bg-blue.png',
    marsImage: '/assets/images/general/back.png',
    character: 'Niron',
    marsSize: 400,
    controlColors: {
        repeat: 'yellow',
        record: 'lightgray',
        check: 'lightgreen'
    },
    notes: [],
    instructions: 'Repeat the syllable shown on the screen.',
    showNotes: true,
    totalLevels: 14,
};

export default sentencesConfig;

